import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useDispatch} from 'react-redux';
import {validateEmail} from 'src/utils/index';

import * as reduxApi from 'src/utils/redux-api-referrer-portal';

import {ERROR_CODES} from 'src/components/authentication/errors';
import {CONSTANTS} from 'src/components/authentication/contants';

import {
  Button,
  Input,
  TitleMedium,
  BodyLarge,
  InContextAlert,
} from '@spaced-out/ui-design-system/lib/components/index';

import css from 'src/components/authentication/forgot/forgot-password/forgot-password.css';


const ForgotPassword = ({
  showConfirmation,
}: {
  showConfirmation: () => unknown;
}) => {
  const dispatch = useDispatch();
  const {t, makeKey} = useLabelTranslation();
  const [email, setEmail] = React.useState('');
  const [apiError, setApiError] = React.useState('');
  const [isSendingEmail, setIsSendingEmail] = React.useState(false);

  const resetPasswordTitle = t(
    makeKey(CONSTANTS.RESET_PASSWORD_TITLE),
    CONSTANTS.RESET_PASSWORD_TITLE,
  );
  const resetPasswordSubtext = t(
    makeKey(CONSTANTS.RESET_PASSWORD_SUBTEXT),
    CONSTANTS.RESET_PASSWORD_SUBTEXT,
  );

  const handleReset = async () => {
    setIsSendingEmail(true);
    await dispatch(reduxApi.post('auth/forget-password', {user_email: email}))
      .then(() => {
        showConfirmation();
      })
      .catch((error) => {
        if (error?.responseBody?.errors && error.responseBody.errors[0]) {
          setApiError(error.responseBody.errors[0]);
        }
      })
      .finally(() => setIsSendingEmail(false));
  };

  const handleEmailChange = (value: string) => {
    if (!value) {
      return;
    }
    setEmail(value);
  };

  return (
    <div className={css.resetSection}>
      <div className={css.titleAndSubtitle}>
        <TitleMedium>{resetPasswordTitle}</TitleMedium>
        <BodyLarge>{resetPasswordSubtext}</BodyLarge>
      </div>
      <div>
        <Input
          label={t('Email', 'Email')}
          placeholder={t('Enter_email', 'Enter email')}
          size="medium"
          type="text"
          value={email}
          error={!!email && !validateEmail(email)}
          errorText={CONSTANTS.INVALID_EMAIL}
          onChange={(e) => handleEmailChange(e.target.value)}
        />
      </div>
      <Button
        size="medium"
        type="primary"
        onClick={handleReset}
        disabled={isSendingEmail || !validateEmail(email)}
      >
        {isSendingEmail
          ? t('Sending_email', 'Sending email')
          : t('Reset_password', 'Reset password')}
      </Button>
      {apiError && (
        <InContextAlert
          semantic="danger"
          classNames={{wrapper: css.errorNotification}}
        >
          {/* @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly InvalidLoginAttempt: "Incorrect email or password"; readonly ServerError: "Failed to perform action, Please try after sometime"; readonly IncorrectOTP: "Invalid OTP entered"; ... 13 more ...; readonly InvalidReferrerEmail: "Invalid Referrer Email"; }'. */}
          {ERROR_CODES[apiError] || apiError}
        </InContextAlert>
      )}
    </div>
  );
};

export default ForgotPassword;
